import clsx from 'clsx';
import { useVisualContext } from '../../components/visual-context';
import { useCurrentMode, useDensityMode, useVisualRefresh } from '../use-visual-mode';
export function usePortalModeClasses(ref) {
    var _a;
    var colorMode = useCurrentMode(ref);
    var densityMode = useDensityMode(ref);
    var context = useVisualContext(ref);
    var visualRefresh = useVisualRefresh(ref);
    return clsx((_a = {
            'awsui-dark-mode': colorMode === 'dark',
            'awsui-compact-mode': densityMode === 'compact',
            'awsui-visual-refresh': visualRefresh
        },
        _a["awsui-context-" + context] = context,
        _a));
}
